// Generated by Copilot- Start
import React from "react";
import DtvBox from "@directv-digital/dds.ui.dtv-box";
import DtvText from "../../../video-lab/dtv-text";
import DtvGrid from "@directv-digital/dds.ui.dtv-grid";
import { colorPalette } from "@directv-digital/dds.ui.dtv-theme";
import Paper from "@mui/material/Paper";
import { ChannelCardV2 } from "lib/helper/channel-interactive-tool-v2";
import { rsnModalStyles } from "./styles";

interface RsnTeamsTableProps {
  channel: ChannelCardV2;
  tierNumber: number;
  showTierSuperscript: boolean;
}

interface Teams {
  mlb?: string;
  nba?: string;
  nhl?: string;
  mls?: string;
  wnba?: string;
}

/**
 * RSN Teams Table Component
 * Displays Regional Sports Network channel information with affiliated teams
 */
const RsnTeamsTable: React.FC<RsnTeamsTableProps> = ({ channel, tierNumber, showTierSuperscript }) => {
  const teams: Teams = {
    mlb: channel.rawData?.mlb,
    nba: channel.rawData?.nba,
    nhl: channel.rawData?.nhl,
    mls: channel.rawData?.mls,
    wnba: channel.rawData?.wnba
  };

  const hasTeams = Object.values(teams).some(team => team);

  if (!hasTeams) {
    return null;
  }

  return (
    <DtvGrid container={true} id="table-view" md={12} sm={12} xs={12} sx={{
 mb: {
 xs: "16px",
sm: "21px"
}
}}>
      {/* Table Header */}
      <DtvGrid container={true} item={true} sm={12} xs={12}>
        <DtvGrid item={true} sm={6} xs={6}>
          <Paper
            elevation={0}
            square={true}
            sx={{
              ...rsnModalStyles.network,
              backgroundColor: "#EAF1FA",
              color: "#102641",
              borderBottom: "0px",
              borderTop: "0px"
            }}
          >
            <DtvText component="p" content="Channel name" gutterBottom={true} sx={rsnModalStyles.tableColHeading} variant="body1medium" />
          </Paper>
        </DtvGrid>
        <DtvGrid item={true} sm={6} xs={6}>
          <Paper
            elevation={0}
            square={true}
            sx={{
              ...rsnModalStyles.network,
              ...rsnModalStyles.affTh,
              ...rsnModalStyles.tableColAffSportHeading,
              borderBottom: "0px",
              borderTop: "0px",
              borderRight: "0px"
            }}
          >
            <DtvText component="p" content="Teams" gutterBottom={true} sx={rsnModalStyles.tableColHeading} variant="body1medium" />
          </Paper>
        </DtvGrid>
      </DtvGrid>

      {/* Table Body */}
      <DtvGrid container={true} sm={12} sx={{ backgroundColor: "#F4F4F4" }} xs={12}>
        <DtvGrid item={true} sm={6} xs={6}>
          <Paper
            elevation={0}
            square={true}
            sx={{
              ...rsnModalStyles.network,
              ...rsnModalStyles.regionalTrHeight,
              ...rsnModalStyles.commonTeamsBodyStyles,
              color: "#102641",
              borderRight: `1px solid ${colorPalette.neutral[300]}`,
              borderBottom: "0px",
              borderTop: "0px",
              backgroundColor: "#F4F4F4"
            }}
          >
            <DtvBox sx={rsnModalStyles.teamsTr}>
              <DtvText
                content={channel.label + (showTierSuperscript ? `<sup style='line-height: 0; vertical-align: super;'>${tierNumber}</sup>` : "")}
                sx={{ borderBottom: "0px" }}
                variant="body2"
              />
              <DtvText content={channel.rawData?.channelNumber ? `Channel ${channel.rawData.channelNumber}` : ""} variant="body2" />
            </DtvBox>
          </Paper>
        </DtvGrid>

        {/* Teams Column */}
        <DtvGrid item={true} sm={6} xs={6}>
          <Paper
            elevation={0}
            square={true}
            sx={{
              ...rsnModalStyles.teams,
              ...rsnModalStyles.regionalTrHeight,
              ...rsnModalStyles.commonTeamsBodyStyles,
              borderBottom: "0px",
              borderTop: "0px",
              backgroundColor: "#F4F4F4",
              border: "0px"
            }}
          >
            <DtvBox sx={rsnModalStyles.teamsTr}>
              {teams.mlb && (
                <DtvBox sx={rsnModalStyles.teamsTrIn}>
                  <DtvText content={teams.mlb} sx={rsnModalStyles.teamsTrVal} variant="body2" />
                </DtvBox>
              )}
              {teams.mls && (
                <DtvBox sx={rsnModalStyles.teamsTrIn}>
                  <DtvText content={teams.mls} sx={rsnModalStyles.teamsTrVal} variant="body2" />
                </DtvBox>
              )}
              {teams.nba && (
                <DtvBox sx={rsnModalStyles.teamsTrIn}>
                  <DtvText content={teams.nba} sx={rsnModalStyles.teamsTrVal} variant="body2" />
                </DtvBox>
              )}
              {teams.nhl && (
                <DtvBox sx={rsnModalStyles.teamsTrIn}>
                  <DtvText content={teams.nhl} sx={rsnModalStyles.teamsTrVal} variant="body2" />
                </DtvBox>
              )}
              {teams.wnba && (
                <DtvBox sx={rsnModalStyles.teamsTrIn}>
                  <DtvText content={teams.wnba} sx={rsnModalStyles.teamsTrVal} variant="body2" />
                </DtvBox>
              )}
            </DtvBox>
          </Paper>
        </DtvGrid>
      </DtvGrid>
    </DtvGrid>
  );
};

export default React.memo(RsnTeamsTable);
// Generated by Copilot- End
